// extracted by mini-css-extract-plugin
export default {"list":"LatestNews_list__kTeX3","link":"LatestNews_link__XNVl6","content":"LatestNews_content__+rxhI","image":"LatestNews_image__RsVh2","headline":"LatestNews_headline__19KtL"};